<template>
    <router-link tag="li" class="nav-item nav-dropdown" :to="url" :class="{ 'open': hasActiveChild }" disabled>
        <div class="nav-link nav-dropdown-toggle" @click="handleClick">
            <i :class="icon"></i> {{name}}
        </div>
        <ul class="nav-dropdown-items">
            <slot></slot>
        </ul>
    </router-link>
</template>

<script>

export default {
    computed: {
        hasActiveChild() {
            // The name is converted to a hyphenated lowercase string
            let name = this.name.replace(/\s+/g, '-').toLowerCase();
            let url = this.$route.path.split('/')[1];

            return name === url ? true : false;
        }
    },

    methods: {
        handleClick(event) {
            event.preventDefault();
            event.target.parentElement.classList.toggle('open');
        }
    }
}
</script>
